import { render, staticRenderFns } from "./checkboxes.vue?vue&type=template&id=230c2561&scoped=true&"
import script from "./checkboxes.vue?vue&type=script&lang=ts&"
export * from "./checkboxes.vue?vue&type=script&lang=ts&"
import style0 from "./checkboxes.vue?vue&type=style&index=0&id=230c2561&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230c2561",
  null
  
)

export default component.exports